import DialogController from "./dialog_controller"

const IN_TRANSITION_SPEED = 300
const OUT_TRANSITION_SPEED = 200

const BACKDROP_TRANSITION_IN = `ease-out duration-${IN_TRANSITION_SPEED}`
const BACKDROP_TRANSITION_OUT = `ease-in duration-${OUT_TRANSITION_SPEED}`
const BACKDROP_HIDE = "opacity-0"
const BACKDROP_SHOW = "opacity-100"

const PANEL_TRANSITION_IN = `ease-out duration-${IN_TRANSITION_SPEED}`
const PANEL_TRANSITION_OUT = `ease-in duration-${OUT_TRANSITION_SPEED}`
const PANEL_HIDE = "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
const PANEL_SHOW = "opacity-100 translate-y-0 sm:scale-100"

export default class extends DialogController {
  transitionBackdropIn() {
    this.applyTransition(this.backdropTarget, {
      enter: BACKDROP_TRANSITION_IN,
      enterFrom: BACKDROP_HIDE,
      enterTo: BACKDROP_SHOW,
    })
  }

  transitionPanelIn() {
    // panel transitions
    this.applyTransition(this.panelTarget, {
      enter: PANEL_TRANSITION_IN,
      enterFrom: PANEL_HIDE,
      enterTo: PANEL_SHOW,
    })
  }

  transitionBackdropOut() {
    this.applyTransition(this.backdropTarget, {
      leave: BACKDROP_TRANSITION_OUT,
      leaveFrom: BACKDROP_SHOW,
      leaveTo: BACKDROP_HIDE,
    })
  }

  transitionPanelOut() {
    this.applyTransition(this.panelTarget, {
      leave: PANEL_TRANSITION_OUT,
      leaveFrom: PANEL_SHOW,
      leaveTo: PANEL_HIDE,
    })
  }

  hideDialog() {
    setTimeout(() => {
      if (!this.openValue) {
        this.dialogTarget.classList.add("hidden")
      }
    }, OUT_TRANSITION_SPEED)
  }

  clickSafeZone() {
    return this.panelTarget.querySelector("div")
  }
}

